import {HttpClient} from "../../http/HttpClient.jsx";
import {message} from "antd";

export const loginOneTapGoogle = async credential => {
    const user = await HttpClient.safePost("/api/google/auth/oneTap", {
        credential
    });

    if (user.error) {
        if (user.status === 400) {
            message.error("יוזר לא נמצא במערכת, לחץ על הרשם למערכת");
        } else {
            message.error(user.error);
        }
    }

    return user;
};

export const loginOneTapAuthCodeGoogle = async code => {
    const user = await HttpClient.safePost("/api/google/auth/oneTap/authCode", {
        code
    });

    if (user.error) {
        if (user.status === 400) {
            message.error("יוזר לא נמצא במערכת, לחץ על הרשם למערכת");
        } else {
            message.error(user.error);
        }
    }

    return user;
};
